module.exports = __webpack_public_path__ + "media/images/number_24-5dfa9108c36dd68ba7f2886d35f11ce6.png";